import { getContext, put, select, takeEvery } from 'redux-saga/effects';
import { ADD_PASSENGER, PassengerAction, REMOVE_PASSENGER, setPassengers, clearPassengers } from './actions';
import { Config } from '../../../context';
import { PassengersState } from './reducers';
import { getPassengersState } from './selectors';
import { PassengerType } from '../../../enums';
import { isResetSelectedOnlyInfants, setPassengerCountLessOrEqualAdt } from './utils';
import { SET_SELECTED_FARE_GROUP } from '../fareGroup/actions';
import { Action } from 'redux-actions';
import { getSelectedFareGroup } from '../fareGroup/selectors';

function* clearConflictedPassengers({ payload: passengerType }: PassengerAction) {
	const {
		SearchForm: { passengersConfig }
	}: Config = yield getContext('config');
	const state: PassengersState = yield select(getPassengersState);

	const newState: PassengersState = {
		...state
	};
	const selectedFareGroup: string = yield select(getSelectedFareGroup);

	passengersConfig
		.filter(config => config.group === selectedFareGroup || (!config.group && selectedFareGroup === 'Standard'))
		.forEach(config => {
			if (config.code === passengerType.passengerType) {
				config.noAvailableWith?.forEach(conflictedCode => {
					newState[conflictedCode] = 0;
				});
			} else if (config.noAvailableWith?.includes(passengerType.passengerType)) {
				newState[config.code] = 0;
			}
		});

	if (isResetSelectedOnlyInfants(newState, passengersConfig)) {
		Object.keys(newState).forEach(type => {
			newState[type] = 0;
		});
	}

	yield put(setPassengers(newState));
}

function* decrementInfants() {
	const {
		SearchForm: { passengersConfig }
	}: Config = yield getContext('config');
	const state: PassengersState = yield select(getPassengersState);
	const selectedFareGroup: string = yield select(getSelectedFareGroup);

	const adultPassengers = passengersConfig
		.filter(config => config.group === selectedFareGroup || (!config.group && selectedFareGroup === 'Standard'))
		.filter(config => config.code === PassengerType.Adult || config.isAdult);

	const adultCount = adultPassengers.reduce((count: number, config) => {
		const currentCount: number = state[config.code];

		return count + currentCount;
	}, 0);

	let newState = {
		...state
	};

	newState = setPassengerCountLessOrEqualAdt(
		newState,
		adultCount,
		passengersConfig.filter(
			config => config.group === selectedFareGroup || (!config.group && selectedFareGroup === 'Standard')
		),
		PassengerType.Infant
	);
	newState = setPassengerCountLessOrEqualAdt(
		newState,
		adultCount,
		passengersConfig.filter(
			config => config.group === selectedFareGroup || (!config.group && selectedFareGroup === 'Standard')
		),
		PassengerType.InfantWithSeat
	);

	yield put(setPassengers(newState));
}

function* handleFareGroupChanged(action: Action<string>) {
	const {
		SearchForm: { passengersConfig }
	}: Config = yield getContext('config');
	yield put(clearPassengers());
	const state: PassengersState = yield select(getPassengersState);
	const newState = { ...state };

	passengersConfig
		.filter(
			passenger =>
				(passenger.group === action.payload && passenger.defaultCount) ||
				(!passenger.group && action.payload === 'Standard' && passenger.defaultCount)
		)
		.forEach(it => {
			newState[it.code] = it.defaultCount;
		});

	yield put(setPassengers(newState));
}

function* handleAddPassenger(action: PassengerAction) {
	yield clearConflictedPassengers(action);
	yield decrementInfants();
}

export default function* passengersSaga() {
	yield takeEvery(ADD_PASSENGER, handleAddPassenger);
	yield takeEvery(REMOVE_PASSENGER, decrementInfants);
	yield takeEvery(SET_SELECTED_FARE_GROUP, handleFareGroupChanged);
}
